import { createStore, applyMiddleware, combineReducers, type Middleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";

import reducer from "./reducers";
import mySaga from "./sagas";
import statsReducer from "./stats/reducer";

const createRootReducer = () =>
  combineReducers({
    basic: reducer,
    stats: statsReducer,
  });

const sagaMiddleware = createSagaMiddleware();
const appMiddleware: Middleware[] = [sagaMiddleware];

// Optionally load redux-logger for better debugging on dev
if (process.env.REDUX_LOGGER_ENABLED) {
  appMiddleware.push(logger as unknown as Middleware);
}

const store = createStore(
  createRootReducer(),
  composeWithDevTools(applyMiddleware(...appMiddleware)),
);

sagaMiddleware.run(mySaga);

export default store;

export type RootState = ReturnType<ReturnType<typeof createRootReducer>>;

export type AppDispatch = typeof store.dispatch;
